import { Warning } from 'components/Confirm';
import history from 'libs/history';

export enum StatusCode {
  success = '2000',
  unauthorized = '40002',
  invalid_token = '40001',
  invalid1_token = '4005',
  no_auth = '3005', // 用户无法识别
  refresh_cookies = '4006', //无效token refresh token
  need_login_again = '40101', //token过期，需要重新登
  disabled = '47060010' // 账号禁用
}

export const ERROR_CODE = [502, 504, 500];

// 回到登录界面
export const goLogin = () => {
  history.push('/login');
};

export const loginAgain = () => {
  return new Promise(() => {
    Warning({
      title: '登录信息缺失,需要重新登录',
      onOk: () => {
        goLogin();
      }
    });
  });
};
